import _indexOf from './_indexOf';

export default function _contains(a, list) {
  return _indexOf(list, a, 0) >= 0;
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_contains.js
// module id = WT/N
// module chunks = 0